import { useAuth } from '../lib/auth';

/**
 * Sign-in screen.
 *
 * There is deliberately NO registration affordance anywhere in this app.
 * Account creation is disabled at the Identity Platform level and rejected by a
 * blocking function; a "Sign up" link would be a lie. R-1.4.
 */
export default function SignIn() {
  const { signIn, error, signedOutReason, loading } = useAuth();

  return (
    <main className="center">
      <div className="card">
        <h1>BeckerSign</h1>
        <p className="muted">Private document signing. Owner access only.</p>

        {signedOutReason && <div className="notice" role="status">{signedOutReason}</div>}
        {error && <div className="alert" role="alert">{error}</div>}

        <button className="primary" onClick={() => void signIn()} disabled={loading}>
          Sign in with Google
        </button>

        <p className="muted" style={{ marginTop: '1.25rem', marginBottom: 0 }}>
          This application has no public registration. Only pre-authorized accounts can sign in.
        </p>
      </div>
    </main>
  );
}
